import React, { ReactNode } from "react";
import { Box, Header } from "@cloudscape-design/components";
import "./section-header.scss";

export interface SectionHeaderProps {
  title: string;
  icon?: ReactNode;
  titleBadge?: ReactNode;
  actions?: ReactNode;
  variant?: "h1" | "h2" | "h3";
  className?: string;
  useGradient?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  icon,
  titleBadge,
  actions,
  variant = "h1",
  className = "",
  useGradient = false,
}) => {
  const headerClasses = [
    "finspace-section-header",
    `finspace-section-header--${variant}`,
    className
  ].filter(Boolean).join(" ");

  const iconClasses = [
    "finspace-section-header__icon",
    useGradient ? "finspace-section-header__gradient-icon" : ""
  ].filter(Boolean).join(" ");

  // Gradient styles for light mode (default)
  const lightGradientStyle = {
    backgroundImage: "linear-gradient(90deg, rgb(0, 102, 204) 0%, rgb(124, 58, 237) 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    display: "inline-block",
  };

  // Gradient styles for dark mode
  const darkGradientStyle = {
    backgroundImage: "linear-gradient(90deg, rgb(99, 179, 255) 0%, rgb(167, 139, 250) 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    filter: "drop-shadow(rgba(0, 0, 0, 0.3) 0px 1px 2px)",
    display: "inline-block",
  };

  return (
    <div className={headerClasses}>
      <div className="finspace-section-header__title-container">
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {icon && <div className={iconClasses}>{icon}</div>}
          <Box variant="awsui-key-label">
            <Header variant={variant}>
              {useGradient ? (
                <>
                  <span className="finspace-gradient-text-light" style={lightGradientStyle}>
                    {title}
                  </span>
                  <span className="finspace-gradient-text-dark" style={darkGradientStyle}>
                    {title}
                  </span>
                </>
              ) : (
                title
              )}
            </Header>
          </Box>
          {titleBadge && <div className="finspace-section-header__title-badge">{titleBadge}</div>}
        </div>
        <div>
          {actions && (
            <div className="finspace-section-header__actions">{actions}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;
